export default __webpack_public_path__ + "static/media/mail-to@2x.f214ee54.png";